import fetchAPI from '../utils/fetchAPI';
import { TFeedItem } from 'types/TFeeds';

type TParams = {
  itemId: string;
  postcode?: string;
  limit?: number;
  latitude?: number;
  longitude?: number;
};

export default function getFranchiseDealerItems({
  itemId,
  postcode,
}: TParams): Promise<{ items: TFeedItem[]; total?: number }> {
  try {
    const itemIdEncoded = encodeURIComponent(itemId);
    const postcodeEncoded = encodeURIComponent(postcode ?? '');

    return fetchAPI({
      url: `/v/api/franchise-dealer-items?itemId=${itemIdEncoded}&postcode=${postcodeEncoded}`,
    });
  } catch {
    return Promise.resolve({ items: [], total: 0 }) as Promise<{ items: TFeedItem[]; total?: number }>;
  }
}
